import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { style: {"float":"right"} }
const _hoisted_2 = { class: "p-input-icon-left mdm-margin-right-s" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_4 = { class: "p-inputgroup" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DodoButton = _resolveComponent("DodoButton")!
  const _component_PrimeDropdown = _resolveComponent("PrimeDropdown")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_PrimeColumn = _resolveComponent("PrimeColumn")!
  const _component_DodoIcon = _resolveComponent("DodoIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!

  return (_ctx.mdmDevices)
    ? (_openBlock(), _createBlock(_component_DataTable, {
        key: 0,
        lazy: true,
        "total-records": _ctx.totalRecords,
        value: _ctx.mdmDevices,
        "data-key": "id",
        "responsive-layout": "scroll",
        paginator: true,
        rows: 10,
        "paginator-template": "CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown",
        "rows-per-page-options": [10,100,1000],
        "current-page-report-template": "Showing {first} to {last} of {totalRecords}",
        "filter-display": "menu",
        onPage: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onPage($event)))
      }, {
        header: _withCtx(() => [
          _createVNode(_component_DodoButton, {
            color: "info",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/policies/bulk')))
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Bulk upload ")
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_PrimeDropdown, {
              modelValue: _ctx.policyFilter,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.policyFilter) = $event)),
              class: "mdm-margin-right-s",
              options: _ctx.mdmPolicies,
              loading: _ctx.mdmPolicies == null,
              "show-clear": _ctx.policyFilter !== null,
              "option-value": "googleId",
              "option-label": "name",
              placeholder: "Filter by policy"
            }, null, 8, ["modelValue", "options", "loading", "show-clear"]),
            _createVNode(_component_PrimeDropdown, {
              modelValue: _ctx.expectedPolicyFilter,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.expectedPolicyFilter) = $event)),
              class: "mdm-margin-right-s",
              options: _ctx.mdmPolicies,
              loading: _ctx.mdmPolicies == null,
              "show-clear": _ctx.expectedPolicyFilter !== null,
              "option-value": "googleId",
              "option-label": "name",
              placeholder: "Filter by expected policy"
            }, null, 8, ["modelValue", "options", "loading", "show-clear"]),
            _createElementVNode("span", _hoisted_2, [
              _hoisted_3,
              _createVNode(_component_InputText, {
                modelValue: _ctx.filter,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.filter) = $event)),
                placeholder: `Search`
              }, null, 8, ["modelValue"])
            ]),
            _createVNode(_component_PrimeDropdown, {
              modelValue: _ctx.filterField,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.filterField) = $event)),
              options: _ctx.filterFieldOptions
            }, null, 8, ["modelValue", "options"])
          ])
        ]),
        default: _withCtx(() => [
          _createVNode(_component_PrimeColumn, {
            field: "id",
            header: "ID"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(_ctx.formatId(data.googleId) || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeColumn, {
            field: "enrollmentTime",
            header: "Enrollment time"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(data.enrollmentTime) || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeColumn, {
            field: "lastPolicySyncTime",
            header: "Last policy sync time"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(data.lastPolicySyncTime) || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeColumn, {
            field: "lastStatusReportTime",
            header: "Last status report time"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(_ctx.formatDate(data.lastStatusReportTime) || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeColumn, {
            field: "serial",
            header: "Serial number"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(data.serial || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeColumn, {
            field: "imei",
            header: "IMEI"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(data.imei || '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeColumn, {
            field: "policyName",
            header: "Policy"
          }, {
            body: _withCtx(({data}) => [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_PrimeDropdown, {
                  modelValue: data.policyName,
                  "onUpdate:modelValue": ($event: any) => ((data.policyName) = $event),
                  class: "mdm-margin-right-s",
                  options: _ctx.mdmPolicies,
                  loading: _ctx.mdmPolicies == null,
                  "option-value": "googleId",
                  "option-label": "name",
                  placeholder: "Select a policy",
                  disabled: !data.googleId
                }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "loading", "disabled"]),
                _createVNode(_component_DodoButton, {
                  variant: "solid",
                  class: "mdm-margin-right-s",
                  disabled: !data.googleId,
                  square: "",
                  color: "info",
                  onClick: ($event: any) => (_ctx.updateMdmDevicePolicy(data))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DodoIcon, {
                      name: "checkmark",
                      fill: ""
                    })
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"]),
                _createVNode(_component_DodoButton, {
                  variant: "solid",
                  square: "",
                  color: "danger",
                  onClick: ($event: any) => (_ctx.deleteDevice(data))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_DodoIcon, {
                      name: "delete",
                      fill: ""
                    })
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 1
          }),
          _createVNode(_component_PrimeColumn, {
            field: "expectedPolicyName",
            header: "Expected policy"
          }, {
            body: _withCtx(({data}) => [
              _createTextVNode(_toDisplayString(_ctx.formatPolicyName(data.expectedPolicyName) || '-'), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["total-records", "value"]))
    : _createCommentVNode("", true)
}